export default {
	install: function(Vue, options) {
		Vue.prototype.navigate = function(route, direction) {
			if (!route.params) route.params = {}
			route.params.direction = direction
			this.$router.push(route)
		}
	}
}
